/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './limit-input.scss';

/* eslint-disable import/no-unresolved, import/default */

import limitInputTemplate from './limit-input.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.components.limitInput', [])
    .directive('tkLimitInput', LimitInput)
    .name;

/*@ngInject*/
function LimitInput($compile, $templateCache) {

    var linker = function (scope, element, attrs, ngModelCtrl) {
        var template = $templateCache.get(limitInputTemplate);
        element.html(template);

        if (angular.isFunction(scope.defaultValue)) {
            scope.defaultValue = Number(scope.defaultValue());
        } else {
            scope.defaultValue = 1;
        }

        scope.$watch('limit', function () {
            updateValue();
        });

        scope.$watch('unlimited', function () {
            updateValue();
        });

        function updateValue() {
            if (scope.unlimited) {
                ngModelCtrl.$setViewValue(-1);
                scope.limit = undefined;
            } else {
                if (!scope.limit) {
                    scope.limit = scope.defaultValue;
                }
                ngModelCtrl.$setViewValue(scope.limit);
            }
            updateValidity();
        }

        ngModelCtrl.$render = function () {
            if (angular.isDefined(ngModelCtrl.$viewValue)) {
                var value = ngModelCtrl.$viewValue;
                if (value == -1) {
                    scope.unlimited  = true;
                    scope.limit = undefined;
                } else {
                    scope.unlimited  = false;
                    scope.limit = value;
                }
            }
        };

        function updateValidity () {
            if (ngModelCtrl.$viewValue) {
                var value = ngModelCtrl.$viewValue;
                if (angular.isUndefined(value) || (value < 1 && value != -1)) {
                    ngModelCtrl.$setValidity('limit', false);
                } else {
                    ngModelCtrl.$setValidity('limit', true);
                }
            }
        }

        $compile(element.contents())(scope);
    }

    return {
        restrict: "E",
        require: "^ngModel",
        scope: {
            disabled:'=ngDisabled',
            title: '@',
            requiredMessage: '@',
            defaultValue: '&'
        },
        link: linker
    };
}



// WEBPACK FOOTER //
// ./src/app/components/limit-input.directive.js